import { FormControl } from "@angular/forms";
import { campo } from "src/interface/campo";
import { ValidatorService } from "src/services/validator.service";
import { GruposAgendas } from "./grupo-agenda";

const validatorService: ValidatorService  = new ValidatorService();

export class DiasNaoAgendamento {

  id: any | null = null;

  nome: campo = {
    title: 'Nome',
    info: 'Nome',
    valor: '',
    placeholder: 'Nome',
    inputType: 'text',
    inputMode: 'text',
    mascara: '',
    maxlength: '1000',
    tipo: null,
    validacoesCustomizadas: ['required'],
    status: new FormControl()
  };

  descricao: campo = {
    title: 'Descrição',
    info: 'Descrição',
    valor: '',
    placeholder: 'Descrição',
    inputType: 'text',
    inputMode: 'text',
    mascara: '',
    maxlength: '1000',
    tipo: null,
    validacoesCustomizadas: [],
    status: new FormControl()
  };

  status: campo = {
    title: 'Status',
    info: 'Status',
    valor: true,
  };

  criado: Date = new Date();

  atualizado: Date = new Date();

  dias: DiaStatus[] = [];

  agendas: GruposAgendas[] = [];

  constructor(){}

  mascara(mascara: string, tipo: string){
    switch (tipo) {
      case "nome":
        this.nome.valor = validatorService.aplicarMascara(this.nome.valor, mascara);
        break;
      case "descricao":
        this.descricao.valor = validatorService.aplicarMascara(this.descricao.valor, mascara);
        break;
      default:
        break;
    }
  }

  validarInput(tipo: string) {
    switch (tipo) {
      case "nome":
        this.nome.valor = this.nome.valor.trim();
        this.nome.status = validatorService.criarValidacao(this.nome.valor, this.nome.validacoesCustomizadas);
        break;
      case "descricao":
        this.descricao.valor = this.descricao.valor.trim();
        this.descricao.status = validatorService.criarValidacao(this.descricao.valor, this.descricao.validacoesCustomizadas);
        break;
      default:
        break;
    }
  }

}

export class DiaStatus{

  id: any | null = null;

  dia: campo = {
    title: 'Data',
    info: 'Data',
    valor: '',
    placeholder: 'Data',
    inputType: 'text',
    inputMode: 'numeric',
    mascara: '',
    maxlength: '10',
    tipo: null,
    validacoesCustomizadas: ['required'],
    status: new FormControl()
  };

  descricao: campo = {
    title: 'Descrição',
    info: 'Descrição',
    valor: '',
    placeholder: 'Descrição',
    inputType: 'text',
    inputMode: 'text',
    mascara: '',
    maxlength: '1000',
    tipo: null,
    validacoesCustomizadas: [],
    status: new FormControl()
  };

  status: campo = {
    title: 'Dia Ativo',
    info: 'Dia Ativo',
    valor: true,
  };

  constructor(){}

  mascara(mascara: string, tipo: string){
    switch (tipo) {
      case "dia":
        this.dia.valor = validatorService.aplicarMascara(this.dia.valor, mascara);
        break;
      case "descricao":
        this.descricao.valor = validatorService.aplicarMascara(this.descricao.valor, mascara);
        break;
      default:
        break;
    }
  }

  validarInput(tipo: string) {
    switch (tipo) {
      case "nome":
        this.dia.valor = this.dia.valor.trim();
        this.dia.status = validatorService.criarValidacao(this.dia.valor, this.dia.validacoesCustomizadas);
        break;
      case "descricao":
        this.descricao.valor = this.descricao.valor.trim();
        this.descricao.status = validatorService.criarValidacao(this.descricao.valor, this.descricao.validacoesCustomizadas);
        break;
      default:
        break;
    }
  }
}
